import React from 'react';

const PostSept11ServiceDescription = (
  <ul>
    <li>Afghanistan</li>
    <li>Djibouti</li>
    <li>Egypt</li>
    <li>Jordan</li>
    <li>Lebanon</li>
    <li>Syria</li>
    <li>Yemen</li>
    <li>Uzbekistan</li>
    <li>The air space above any of these locations</li>
  </ul>
);

export default PostSept11ServiceDescription;
